import React from 'react';
import {useAuth} from "context/AuthContext";
import {PencilIcon, TrashIcon} from "@heroicons/react/solid";
import Dropdown, {DropdownItem} from "components/Dropdown";
import {useNavigate} from "react-router-dom";
import {FacilityType} from "types/FacilityType";

// Types ----

type FacilityTypeContextMenuProps = {
  facilityType: FacilityType
  onDeleteFacilityType: () => void
  editDisabled?: boolean
  deleteDisabled?: boolean
  position?: 'left' | 'right'
};

// Component ----

function FacilityTypeContextMenu({facilityType, onDeleteFacilityType, editDisabled, deleteDisabled, position = 'right'}: FacilityTypeContextMenuProps) {
  const auth = useAuth();
  const navigate = useNavigate();

  function editFacilityType() {
    void navigate(`/facility-types/${facilityType.id}/edit`)
  }

  return (
    <Dropdown hideIfEmpty position={position}>
      {auth.can('facility-types:write') &&
        <DropdownItem name={'Edit'} icon={PencilIcon} onClick={editFacilityType} disabled={!!editDisabled}/>
      }

      {auth.can('facility-types:write') &&
        <DropdownItem name={'Delete'} icon={TrashIcon} onClick={onDeleteFacilityType} disabled={!!deleteDisabled}/>
      }
    </Dropdown>
  );
}

export default FacilityTypeContextMenu;